// generated by genversion
export var version = '4.1.3';
//# sourceMappingURL=version.js.map